(function () {
  $(document).ready(() => {
    $("[data-video-trigger]").on("click", playVideo);
  });

  function playVideo() {
    const $video = $("[data-video-src]");
    const $playButton = $("[data-video-trigger]");
    $playButton.fadeOut();
    $video.attr("src", $video.attr("data-video-src"));
    $video.attr("controls", true);
    $video[0].currentTime = 0;
    $video[0].play();
  }
})();
